<ng-container>
    <div class="grid-1col input-grid-gaps">
        <app-date-input
            [form]="form"
            id="dateFrom"
            [prefix]="prefix"
            [disabled]="!store.items()"
        ></app-date-input>
        <app-date-input
            [form]="form"
            id="dateTo"
            [prefix]="prefix"
            [disabled]="!store.items()"
        ></app-date-input>
        <app-select-input
            [form]="form"
            id="accountingType"
            [prefix]="prefix"
            [staticOptions]="accountingTypeOptions"
            [showClear]="false"
            [disabled]="!store.items()"
        ></app-select-input>
    </div>
</ng-container>
